import { create } from "zustand";

interface AlertDetailState {
  /** A real alert id opened directly (feed, tables, map card), or null. */
  realAlertId: number | null;
  /** Open directly from a real alert id. */
  openReal: (id: number) => void;
  close: () => void;
}

export const useAlertDetailStore = create<AlertDetailState>()((set) => ({
  realAlertId: null,
  openReal: (id) => set({ realAlertId: id }),
  close: () => set({ realAlertId: null }),
}));
